export default {
  marketing: {
    cookie: ["ads/ga-audiences"],
  }
};
